//import { createFocusTrap } from "focus-trap";

const Header = {
  focusTrap: null,
  focusTrapElement: null,
  bodyWrapper: null,

  init: () => {
    // get html element
    const htmlEl = document.querySelector("html");

    // get mobile nav btn
    const btn = document.getElementById("header__btn");

    // set focus trap element
    Header.focusTrapElement = document.getElementById("header");

    // set body wrapper element
    Header.bodyWrapper = document.querySelector(".wrapper");

    // Initialize focus trap
    // if (Header.focusTrapElement) {
    //   Header.focusTrap = createFocusTrap("#header", {
    //     onActivate: () => Header.focusTrapElement.classList.add("is-active"),
    //     onDeactivate: () =>
    //       Header.focusTrapElement.classList.remove("is-active"),
    //   });
    // }

    // mobile nav toggle
    if (btn) {
      btn.addEventListener("click", function () {
        // get aria labels
        const labelOpen = btn.dataset.ariaLabelOpen;
        const labelClose = btn.dataset.ariaLabelClose;

        // toggle aria expanded attr
        let isExpanded = btn.getAttribute("aria-expanded") === "true" || false;
        btn.setAttribute("aria-expanded", !isExpanded);

        // set class to html element
        if (htmlEl) htmlEl.classList.toggle("nav-expanded");

        // toggle aria labels
        if (!isExpanded) {
          btn.setAttribute("aria-label", labelClose);
        } else {
          btn.setAttribute("aria-label", labelOpen);
        }
      });
    }
  },
};

export default Header;
